import {
  get, post, put, remove
} from '../../api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_DELETE_FAIL,
  COMMON_DATA_DELETE_SUCCESS,
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS
} from '../../constants/notification-settings';

export const FETCH_COLLECTIONS_START = 'FETCH_COLLECTIONS_START';
export const FETCH_COLLECTIONS_SUCCESS = 'FETCH_COLLECTIONS_SUCCESS';
export const FETCH_COLLECTIONS_FAIL = 'FETCH_COLLECTIONS_FAIL';

export const FETCH_COLLECTION_START = 'FETCH_COLLECTION_START';
export const FETCH_COLLECTION_SUCCESS = 'FETCH_COLLECTION_SUCCESS';
export const FETCH_COLLECTION_FAIL = 'FETCH_COLLECTION_FAIL';

export const CREATE_COLLECTION_START = 'CREATE_COLLECTION_START';
export const CREATE_COLLECTION_SUCCESS = 'CREATE_COLLECTION_SUCCESS';
export const CREATE_COLLECTION_FAIL = 'CREATE_COLLECTION_FAIL';

export const UPDATE_COLLECTION_START = 'UPDATE_COLLECTION_START';
export const UPDATE_COLLECTION_SUCCESS = 'UPDATE_COLLECTION_SUCCESS';
export const UPDATE_COLLECTION_FAIL = 'UPDATE_COLLECTION_FAIL';

export const DELETE_COLLECTION_START = 'DELETE_COLLECTION_START';
export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';
export const DELETE_COLLECTION_FAIL = 'DELETE_COLLECTION_FAIL';

const fetchCollectionsStart = () => ({
  type: FETCH_COLLECTIONS_START,
});

export const fetchCollectionsSuccess = (payload) => ({
  type: FETCH_COLLECTIONS_SUCCESS,
  payload,
});

const fetchCollectionsFail = (error) => ({
  type: FETCH_COLLECTIONS_FAIL,
  payload: error,
});

export const fetchCollections = ({ limit, offset, lang }) => async (dispatch) => {
  dispatch(fetchCollectionsStart());
  try {
    const result = await get(`/integration-collections?limit=${limit}&offset=${offset}&langCode=${lang}`);
    dispatch(fetchCollectionsSuccess(result.data));
  } catch (e) {
    dispatch(fetchCollectionsFail(e));
  }
};

const fetchCollectionStart = (id) => ({
  type: FETCH_COLLECTIONS_START,
  payload: id,
});

const fetchCollectionSuccess = (payload) => ({
  type: FETCH_COLLECTION_SUCCESS,
  payload,
});

const fetchCollectionFail = (error) => ({
  type: FETCH_COLLECTION_FAIL,
  payload: error,
});

export const fetchCollection = (id) => async (dispatch) => {
  dispatch(fetchCollectionStart());
  try {
    const result = await get(`/integration-collections/${id}`);
    dispatch(fetchCollectionSuccess(result.data));
    return result.data;
  } catch (e) {
    dispatch(fetchCollectionFail(e));
    return null;
  }
};

const createCollectionStart = () => ({
  type: CREATE_COLLECTION_START,
});

export const createCollectionSuccess = (payload) => ({
  type: CREATE_COLLECTION_SUCCESS,
  payload,
});

const createCollectionFail = (error) => ({
  type: CREATE_COLLECTION_FAIL,
  payload: error,
});

export const createCollection = (data, translations, setNewItemProcess) => async (dispatch) => {
  dispatch(createCollectionStart());
  try {
    const result = await post('/integration-collections', data);
    if (result?.data) {
      dispatch(createCollectionSuccess(result?.data));
      Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    } else {
      Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    }
    setNewItemProcess((prev) => prev.filter((elId) => elId !== data.identifier));
  } catch (e) {
    dispatch(createCollectionFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
  }
};

const updateCollectionStart = () => ({
  type: UPDATE_COLLECTION_START,
});

const updateCollectionSuccess = (payload) => ({
  type: UPDATE_COLLECTION_SUCCESS,
  payload,
});

const updateCollectionFail = (error) => ({
  type: UPDATE_COLLECTION_FAIL,
  payload: error,
});

export const updateCollection = (data, lang, translations, silent = true) => async (dispatch) => {
  dispatch(updateCollectionStart());
  try {
    const result = await put(`/integration-collections/${data.id}?langCode=${lang}`, data);
    dispatch(updateCollectionSuccess(result));
    if (!silent) {
      Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    }
    return true;
  } catch (e) {
    dispatch(updateCollectionFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

const deleteCollectionStart = () => ({
  type: DELETE_COLLECTION_START,
});

const deleteCollectionSuccess = (payload) => ({
  type: DELETE_COLLECTION_SUCCESS,
  payload,
});

const deleteCollectionFail = (error) => ({
  type: DELETE_COLLECTION_FAIL,
  payload: error,
});

export const deleteCollection = (id, translations, setDeleteProcess) => async (dispatch) => {
  dispatch(deleteCollectionStart());
  try {
    await remove(`/integration-collections/${id}`);
    dispatch(deleteCollectionSuccess(id));
    setDeleteProcess((prev) => prev.filter((elId) => elId !== id));
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
  } catch (e) {
    dispatch(deleteCollectionFail(e));
    setDeleteProcess((prev) => prev.filter((elId) => elId !== id));
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
  }
};
